// Local-only API key handling. Keys live ONLY in this browser (localStorage) and
// are attached per-request as headers. They are never sent to Supabase or stored
// on the server. Clearing them here removes them everywhere they exist.

const LS = 'autoworld.keys.v1'

export function loadKeys() {
  try { return JSON.parse(localStorage.getItem(LS) || '{}') } catch { return {} }
}
export function saveKeys(keys) {
  localStorage.setItem(LS, JSON.stringify(keys || {}))
}
export function clearKeys() { localStorage.removeItem(LS) }

// Header map for per-request secret passing (transient, never persisted server-side).
export function keyHeaders() {
  const k = loadKeys()
  const h = {}
  if (k.anthropic) h['x-anthropic-key'] = k.anthropic
  if (k.meshy) h['x-meshy-key'] = k.meshy
  if (k.github) h['x-github-token'] = k.github
  if (k.netlify) h['x-netlify-token'] = k.netlify
  return h
}
